import { useEffect, useState } from "react";
import { Input, Select, Option } from "@material-tailwind/react";
import NextBack from "./NextBack";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  boatPriceForm,
  boatPriceSchema,
} from "../../pages/boat/createBoatValidation";
import ErrorParagraph from "../common/ErrorParagraph";
import api from "../../services/apiService";
import ApiRoutes from "../../services/apiRoutes";
import { useMutation, useQuery } from "react-query";
import { handleErrorMessage } from "../../utility";
import { toast } from "react-toastify";
import { PricingAvailability } from "../../models/boat/pricingAvailability";
import DefaultLoading from "../common/DefaultLoading";
import ErrorLoadingState from "../common/buttons/ErrorLoadingState";
import { useSelectedBoatStore } from "../../store/boat/boatDetails";
import { useNavigate } from "react-router-dom";
import { routerPaths } from "../../services/path";

function EditPricing() {
  const noStateSelected = "Please Select State";
  const [availability, setAvailability] = useState(noStateSelected);

  const { selectedBoat } = useSelectedBoatStore();
  const navigate = useNavigate();
  const { isLoading, data, error } = useQuery<PricingAvailability>(
    "Edit Boat Pricing",
    () => api.get(ApiRoutes.getTripAvailability),
    {
      onError: (error) => {
        console.log(error);
      },
      onSuccess: (data) => {
        console.log(data);
      },
    }
  );

  const handleStateChange = (value: string | undefined) => {
    if (!value) return;
    const availability = value;
    console.log(value);
    setAvailability(value);
    setValue("tripAvailabilityOptions", availability);
  };

  const {
    register,
    handleSubmit,
    setValue,

    formState: { errors },
  } = useForm<boatPriceForm>({
    resolver: yupResolver(boatPriceSchema),
  });

  const onSubmit = (data: boatPriceForm) => {
    const boatId = selectedBoat?.boatId;
    if (boatId === undefined) return;
    const price = { ...data, boatId: boatId };
    console.log(price);
    createPricingMutation.mutate(price);
  };

  const createPricingMutation = useMutation(
    (data: boatPriceForm) => api.post(ApiRoutes.boatPrice, data),
    {
      onSuccess: (data) => {
        console.log(data);
        navigate(routerPaths.boat);
        toast.success("Pricing updated successfully");
      },
      onError: (error) => {
        handleErrorMessage(
          error,
          "Unable to update pricing please try again later"
        );
      },
    }
  );
  useEffect(() => {
    if (selectedBoat === undefined) {
      navigate(routerPaths.boat);
    }
  }, [navigate, selectedBoat]);

  if (isLoading)
    return (
      <div className="flex items-center justify-center h-screen">
        <DefaultLoading />
      </div>
    );

  if (error) {
    return (
      <div className="h-screen">
        <ErrorLoadingState />
      </div>
    );
  }

  return (
    <div>
      <form
        className="flex flex-col items-center justify-center min-h-[80vh] px-6"
        onSubmit={() => handleSubmit(onSubmit)}
      >
        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Prices of hire per hour (Naira)"
            defaultValue={selectedBoat?.hourlyRate}
            {...register("hourlyRate")}
          />
          {errors.hourlyRate && (
            <ErrorParagraph message={errors.hourlyRate.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Select
            placeholder={undefined}
            value={availability}
            {...register("tripAvailabilityOptions")}
            onChange={(value) => handleStateChange(value)}
            label="Availability"
          >
            {data?.data.payload.data.map((item) => (
              <Option key={item.id} value={item.id.toString()}>
                {item.name}
              </Option>
            ))}
          </Select>

          {errors.tripAvailabilityOptions && (
            <ErrorParagraph message={errors.tripAvailabilityOptions.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Penalty fee for delay (in percentage)"
            defaultValue={selectedBoat?.penaltyFee}
            {...register("penaltyFee")}
          />
          {errors.penaltyFee && (
            <ErrorParagraph message={errors.penaltyFee.message!} />
          )}
        </div>

        <div className=" m-2 md:w-1/2 w-full">
          <Input
            crossOrigin={undefined}
            label="Seat capacity"
            defaultValue={selectedBoat?.seatCapacity}
            {...register("seatCapacity")}
          />
          {errors.seatCapacity && (
            <ErrorParagraph message={errors.seatCapacity.message!} />
          )}
        </div>
      </form>
      <NextBack
        shouldGoNext={true}
        shouldGoBack={true}
        isLoading={createPricingMutation.isLoading}
        next={() => handleSubmit(onSubmit)()}
        back={() => {
          navigate(routerPaths.boat);
        }}
      />
    </div>
  );
}

export default EditPricing;
